import {notesOrder} from '../../pages/HandoverNotesPage/HandoverNotesHelpers';

type NoteWithDisplayName = {displayName?: string | null};

const orderLower = notesOrder.map((item) => item.toLowerCase());

export function sortNotesByCategory<T extends NoteWithDisplayName>(
  notes: readonly T[]
): T[] {
  const getIndex = (note: T) => {
    const idx = orderLower.indexOf((note.displayName ?? '').toLowerCase());
    // unknown / missing categories sort to the end in stable insertion order
    return idx === -1 ? orderLower.length : idx;
  };
  return [...notes].sort((a, b) => getIndex(a) - getIndex(b));
}
